import CreateNoteModal from './CreateNoteModal.vue';

export default CreateNoteModal;
